export default __webpack_public_path__ + "static/media/exito-2.5c1b6ca9.png";